import React, { useState, useEffect } from "react";
import Alert from "../../layouts/Alert";
import Pagination from "../../layouts/Pagination";
import _ from "lodash";
import PMResultListItem from "./PMResultListItem";
import Search from "../../layouts/Search";
import ResultFilter from "../results/ResultFilter";
import SortIcon from "../../layouts/SortIcon";

const PMResultsList = ({
  user,
  pmresultsList,
  pmresultListLoading,
  isPMMode,
  selectedUser,
}) => {
  const [listSearch, setListSearch] = useState(pmresultsList);

  const [search, setSearch] = useState("");
  const [done, setDone] = useState(false);
  const [formData, setFormData] = useState({
    AccessCode: "",
    Title: "",
    AssessmentType: null,
    LevelID: null,
    ProbeID: null,
    riskStatus: null,
    CreatedDate: null,
  });

  const [page, setPage] = useState(1);
  const itemsPerPage = 15;

  const [sortKeys, setSortKeys] = useState([]);

  const [isShowIcon, setIsShowIcon] = useState(null);

  const [icons, setIcons] = useState({
    AccessCode: 0,
    Title: 0,
    AssessmentType: 0,
    LevelID: 0,
    ProbeID: 0,
    riskStatus: 0,
    CreatedDate: 0,
  });

  const {
    AccessCode,
    Title,
    AssessmentType,
    LevelID,
    ProbeID,
    CreatedDate,
    riskStatus,
  } = icons;

  useEffect(() => {
    if (sortKeys.length > 0) {
      setListSearch(
        _.orderBy(
          searchInput(filterInput(pmresultsList, formData), search),
          getKeys(sortKeys),
          getOrder(sortKeys),
        ),
      );
    } else {
      setListSearch(searchInput(filterInput(pmresultsList, formData), search));
    }
  }, [sortKeys]);

  useEffect(() => {
    if (!pmresultListLoading) {
      const combined = getCombinedAndFilteredResults(pmresultsList);
      setListSearch(
        combined.sort((a, b) => {
          const aHasAccessCode =
            !!a.AccessCode && String(a.AccessCode).trim() !== "";
          const bHasAccessCode =
            !!b.AccessCode && String(b.AccessCode).trim() !== "";

          // Always pin records with AccessCode to the top of the list.
          if (aHasAccessCode !== bHasAccessCode) {
            return aHasAccessCode ? -1 : 1;
          }

          // Check if either a or b has a null CreatedDate
          if (!a.CreatedDate && !b.CreatedDate) {
            return 0; // If both are null, they are considered equal
          } else if (!a.CreatedDate) {
            return 1; // If only a is null, it should come after b
          } else if (!b.CreatedDate) {
            return -1; // If only b is null, it should come after a
          }

          // If both a and b have valid dates, compare them normally
          return new Date(b.CreatedDate) - new Date(a.CreatedDate);
        }),
      );
    }
  }, [pmresultListLoading, setListSearch, pmresultsList]);

  const getKeys = (arr) => {
    return arr.map((a) => a.key);
  };
  const getOrder = (arr) => {
    return arr.map((a) => a.order);
  };

  const setFilter = (data) => {
    setIcons({
      AccessCode: 0,
      Title: 0,
      AssessmentType: 0,
      LevelID: 0,
      ProbeID: 0,
      riskStatus: 0,
      CreatedDate: 0,
    });
    setListSearch(filterInput(listSearch, data));
  };

  // Helper function to get a reference info from ResultRef JSON string
  const getRefInfo = (resultRef) => {
    if (resultRef && resultRef !== "") {
      try {
        const parsedRef = JSON.parse(resultRef);
        return {
          ResultID: parsedRef.ResultID,
          AssessmentSkill: parsedRef.AssessmentSkill,
        };
      } catch (e) {
        return null;
      }
    }
    return null;
  };

  // Helper function to filter and combine related results
  const getCombinedAndFilteredResults = (results) => {
    const secondaryMap = {};
    const primary = [];
    const processed = new Set();

    // First pass: build map of secondary results by primary ID
    results.forEach((result) => {
      const refInfo = getRefInfo(result.ResultRef);
      if (refInfo) {
        // This is a secondary result (has a ResultRef pointing to primary)
        if (
          (result.CategoryID === 4 && refInfo.AssessmentSkill === "WWR") ||
          (result.CategoryID === 3 && refInfo.AssessmentSkill === "%")
        ) {
          secondaryMap[refInfo.ResultID] = result;
        }
      }
    });

    // Second pass: collect primary results and attach secondary data
    results.forEach((result) => {
      if (processed.has(result.ResultID)) return;

      const refInfo = getRefInfo(result.ResultRef);
      const isPrimary =
        (result.CategoryID === 4 && refInfo?.AssessmentSkill === "CLS") ||
        (result.CategoryID === 3 && refInfo?.AssessmentSkill === "TWC") ||
        (result.CategoryID !== 4 && result.CategoryID !== 3) ||
        result.AccessCode;

      if (isPrimary) {
        // Attach secondary result if it exists
        const secondary = secondaryMap[result.ResultID];
        const combinedResult = {
          ...result,
          _secondary: secondary || null,
        };
        primary.push(combinedResult);
        processed.add(result.ResultID);
        if (secondary) {
          processed.add(secondary.ResultID);
        }
      }
    });

    return primary;
  };

  const searchInput = (arr, word) => {
    return arr;
  };

  const filterInput = (arr, data) => {
    return arr;
  };

  return (
    <div className="card w-100 p-2 p-sm-3 p-lg-5 shadow-lg border-0 users-list ">
      <Alert />
      <div className="d-flex w-100 align-items-center justify-content-between mb-3">
        <div className="d-flex align-items-center">
          {!pmresultListLoading && (
            <Pagination
              totalItems={listSearch.length} // Total number of items
              itemsPerPage={itemsPerPage} // Number of items per page
              currentPage={page} // Current active page
              onPageChange={setPage} // Callback function to change page
              maxPagesToShow={10} // Maximum number of pages to display (optional)
            />
          )}
        </div>
        <div className="d-flex">
          {/* <Search
              setListSearch={setListSearch}
              setSearch={setSearch}
              filter={(e) => {
                setIcons({
                  AccessCode: 0,
                  Title: 0,
                  AssessmentType: 0,
                  LevelID: 0,
                  ProbeID: 0,
                  riskStatus:0,
                  CreatedDate: 0,
                });

                return searchInput(
                  filterInput(pmresultsList, formData),
                  e.target.value,
                );
              }}
            /> */}
          {/* <ResultFilter
              setFilter={setFilter}
              resultsList={pmresultsList}
              setListSearch={setListSearch}
              searchInput={searchInput}
              search={search}
              formData={formData}
              setFormData={setFormData}
            /> */}
        </div>
      </div>
      <div className="admin-users-fields  d-flex align-items-center justify-content-around  rounded  bg-body txt-primary">
        <div
          className="admin-users-field text-truncate"
          onClick={() => {
            if (LevelID === 0) {
              setSortKeys([...sortKeys, { key: "LevelID", order: "asc" }]);
              setIcons({ ...icons, LevelID: 1 });
            } else if (LevelID === 1) {
              setSortKeys(
                sortKeys.map((a) => {
                  if (a.key === "LevelID") return { ...a, order: "desc" };
                  return a;
                }),
              );
              setIcons({
                ...icons,
                LevelID: -1,
              });
            } else {
              setSortKeys(sortKeys.filter((a) => a.key !== "LevelID"));
              setIcons({
                ...icons,
                LevelID: 0,
              });
            }
          }}
          onMouseEnter={() => setIsShowIcon("LevelID")}
          onMouseLeave={() => setIsShowIcon(null)}
        >
          PM Level
          <SortIcon icon={LevelID} isShowIcon={isShowIcon === "LevelID"} />
        </div>

        <div
          className="admin-assessments-field d-flex align-items-center"
          onClick={() => {
            if (AssessmentType === 0) {
              setSortKeys([
                ...sortKeys,
                { key: "AssessmentType", order: "asc" },
              ]);
              setIcons({ ...icons, AssessmentType: 1 });
            } else if (AssessmentType === 1) {
              setSortKeys(
                sortKeys.map((a) => {
                  if (a.key === "AssessmentType")
                    return { ...a, order: "desc" };
                  return a;
                }),
              );
              setIcons({
                ...icons,
                AssessmentType: -1,
              });
            } else {
              setSortKeys(sortKeys.filter((a) => a.key !== "AssessmentType"));
              setIcons({
                ...icons,
                AssessmentType: 0,
              });
            }
          }}
          onMouseEnter={() => setIsShowIcon("AssessmentType")}
          onMouseLeave={() => setIsShowIcon(null)}
        >
          <span className="text-truncate flex-grow-1">Assessment Type</span>
          <SortIcon
            icon={AssessmentType}
            isShowIcon={isShowIcon === "AssessmentType"}
          />
        </div>

        <div
          className="admin-users-field  text-truncate d-md-block d-none"
          onClick={() => {
            if (Title === 0) {
              setSortKeys([...sortKeys, { key: "Title", order: "asc" }]);
              setIcons({
                ...icons,
                Title: 1,
              });
            } else if (Title === 1) {
              setSortKeys(
                sortKeys.map((a) => {
                  if (a.key === "Title") return { ...a, order: "desc" };
                  return a;
                }),
              );
              setIcons({
                ...icons,
                Title: -1,
              });
            } else {
              setSortKeys(sortKeys.filter((a) => a.key !== "Title"));
              setIcons({
                ...icons,
                Title: 0,
              });
            }
          }}
          onMouseEnter={() => setIsShowIcon("Title")}
          onMouseLeave={() => setIsShowIcon(null)}
        >
          Title
          <SortIcon icon={Title} isShowIcon={isShowIcon === "Title"} />
        </div>

        <div
          className="admin-probe-field  text-truncate d-md-block d-none"
          onClick={() => {
            if (ProbeID === 0) {
              setSortKeys([...sortKeys, { key: "ProbeID", order: "asc" }]);
              setIcons({
                ...icons,
                ProbeID: 1,
              });
            } else if (ProbeID === 1) {
              setSortKeys(
                sortKeys.map((a) => {
                  if (a.key === "ProbeID") return { ...a, order: "desc" };
                  return a;
                }),
              );
              setIcons({
                ...icons,
                ProbeID: -1,
              });
            } else {
              setSortKeys(sortKeys.filter((a) => a.key !== "ProbeID"));
              setIcons({
                ...icons,
                ProbeID: 0,
              });
            }
          }}
          onMouseEnter={() => setIsShowIcon("ProbeID")}
          onMouseLeave={() => setIsShowIcon(null)}
        >
          Probe
          <SortIcon icon={ProbeID} isShowIcon={isShowIcon === "ProbeID"} />
        </div>

        {/* Field: Risk Status */}
        <div
          className="admin-riskstatus-field  text-truncate d-md-block d-none"
          onClick={() => {
            if (riskStatus === 0) {
              setSortKeys([...sortKeys, { key: "riskStatus", order: "asc" }]);
              setIcons({
                ...icons,
                riskStatus: 1,
              });
            } else if (riskStatus === 1) {
              setSortKeys(
                sortKeys.map((a) => {
                  if (a.key === "riskStatus") return { ...a, order: "desc" };
                  return a;
                }),
              );
              setIcons({
                ...icons,
                riskStatus: -1,
              });
            } else {
              setSortKeys(sortKeys.filter((a) => a.key !== "riskStatus"));
              setIcons({
                ...icons,
                riskStatus: 0,
              });
            }
          }}
          onMouseEnter={() => setIsShowIcon("riskStatus")}
          onMouseLeave={() => setIsShowIcon(null)}
        >
          Benchmark Status
          <SortIcon
            icon={riskStatus}
            isShowIcon={isShowIcon === "riskStatus"}
          />
        </div>

        {/* Assessment Completion/Assignment Date */}
        <div
          className="admin-users-field d-flex align-items-center"
          onClick={() => {
            if (CreatedDate === 0) {
              setSortKeys([...sortKeys, { key: "CreatedDate", order: "asc" }]);
              setIcons({
                ...icons,
                CreatedDate: 1,
              });
            } else if (CreatedDate === 1) {
              setSortKeys(
                sortKeys.map((a) => {
                  if (a.key === "CreatedDate") return { ...a, order: "desc" };
                  return a;
                }),
              );
              setIcons({
                ...icons,
                CreatedDate: -1,
              });
            } else {
              setSortKeys(sortKeys.filter((a) => a.key !== "CreatedDate"));
              setIcons({
                ...icons,
                CreatedDate: 0,
              });
            }
          }}
          onMouseEnter={() => setIsShowIcon("CreatedDate")}
          onMouseLeave={() => setIsShowIcon(null)}
        >
          <span className="text-truncate flex-grow-1">Completion Date</span>
          <SortIcon
            icon={CreatedDate}
            isShowIcon={isShowIcon === "CreatedDate"}
          />
        </div>

        <div className="admin-users-field text-truncate ml-1">Actions</div>
      </div>
      <div className="users-list-body ">
        {pmresultListLoading ? (
          <div className="d-flex justify-content-center align-items-center h-100">
            <div class="spinner-border txt-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : listSearch.length === 0 ? (
          <div className="d-flex justify-content-center align-items-center h-100 my-4">
            <p>
              {" "}
              Assign Progress Monitoring for the students to begin.
              <br /> Follow <b>STEPS TO PROGRESS MONITOR</b>
            </p>
          </div>
        ) : (
          listSearch
            .sort((a, b) => new Date(b.CreatedDate) - new Date(a.CreatedDate))
            .slice(15 * (page - 1), 15 * page)
            .map((result, id) => {
              return (
                <PMResultListItem
                  result={result}
                  key={result.ResultID}
                  user={user}
                  isPMMode={isPMMode}
                  done={done}
                  setDone={setDone}
                />
              );
            })
        )}
      </div>
    </div>
  );
};

export default PMResultsList;
